module.exports = __webpack_public_path__ + "static/media/Ticketing-Plus-Coral.28ba07b1.svg";